import { Modal } from '@thanx/uikit/modal'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import { type KeyboardEvent } from 'react'

import ActivationModalActions from './ActivationModalActions'
import ActivationRadioGroup from './ActivationRadioGroup'
import './SegmentActivationModal.scss'

const t = buildTranslate('components.ai.segment_activation_modal')

export interface SegmentActivationModalProps {
  isOpen: boolean
  autoApprove: boolean
  rememberChoice: boolean
  isSaving: boolean
  error: string | null
  onReviewOptionSelected: () => void
  onActivateOptionSelected: () => void
  onActivateOptionKeyDown: (e: KeyboardEvent) => void
  onRememberToggled: () => void
  onSaveClicked: () => void
  onCloseClicked: () => void
}

const SegmentActivationModal = ({
  isOpen,
  autoApprove,
  rememberChoice,
  isSaving,
  error,
  onReviewOptionSelected,
  onActivateOptionSelected,
  onActivateOptionKeyDown,
  onRememberToggled,
  onSaveClicked,
  onCloseClicked,
}: SegmentActivationModalProps) => (
  <Modal
    overrides={{
      Root: { style: { zIndex: 1100 } },
      Dialog: {
        style: () => ({
          borderRadius: '4px',
          border: 'none',
          boxShadow: '0px 4px 8px rgba(54, 66, 78, 0.3)',
          width: '600px',
        }),
      },
    }}
    isOpen={isOpen}
    onClose={onCloseClicked}
    closeable={!isSaving}
    size="auto"
  >
    <div className="segment-activation-modal p-xl">
      <Text.Header3 tag="div" color="grey90" className="mb-xs">
        {t('title')}
      </Text.Header3>
      <Text.BodyText4 tag="div" color="grey70" className="mb-l">
        {t('subtitle')}
      </Text.BodyText4>

      <ActivationRadioGroup
        autoApprove={autoApprove}
        rememberChoice={rememberChoice}
        onReviewOptionSelected={onReviewOptionSelected}
        onActivateOptionSelected={onActivateOptionSelected}
        onActivateOptionKeyDown={onActivateOptionKeyDown}
        onRememberToggled={onRememberToggled}
      />

      {error && (
        <Text.BodyText4 tag="div" color="cayenne50" className="mt-s">
          {error}
        </Text.BodyText4>
      )}

      <ActivationModalActions
        isSaving={isSaving}
        onCancelClicked={onCloseClicked}
        onSaveClicked={onSaveClicked}
      />
    </div>
  </Modal>
)

export default SegmentActivationModal
